export default __webpack_public_path__ + "static/media/Nine.21127f9e.jpg";